"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tags = require("./Tags.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Tags = function Tags(_ref) {
  var list = _ref.list;
  return _react["default"].createElement(_Tags.StyleBase, null, list.map(function (tag, i) {
    return _react["default"].createElement(_Tags.Tag, {
      key: "majorelle-tag-".concat(tag, "-").concat(i)
    }, tag);
  }));
};

Tags.propTypes = {
  list: _propTypes["default"].array
};
Tags.defaultProps = {
  list: []
};
var _default = Tags;
exports["default"] = _default;